import React from 'react';

export default function About() {
  return (
    <div style={{ padding: '2rem', maxWidth: '900px', margin: 'auto' }}>
      <h2>About GISVEC</h2>
      <p>
        GISVEC is an open-source GIS-focused portfolio and demo site. 
        This is a place for me(cartacq) to learn coding and web development while
        showcasing GIS-related projects.
      </p>
      <br></br>
      <p>
        You can contact me via the Contact page for inquiries or collaborations.
      </p>
      <br></br>
      <h2>About Cartacq</h2>
      <p>
        Cartacq is a GIS enthusiast and aspiring web developer. 
        With a passion for maps and spatial data, Cartacq created GISVEC to share projects and learn new skills in coding and web development.
      </p>
    </div>

  );
}
